<div id="session-expiration" class="modal-dialog session-expiration">
  <div>
    <div class="modal-header">
      <div>
        <h4>Session Expiration Warning</h4>
      </div>
    </div>
    <div class="modal-body">
      <p>Your session expires in:<span class="time-remaining"> <strong>{{tick}}</strong> minutes.</span> To continue working, click<span class="keep-me-logged-in">&nbsp;"Keep Me Logged In".</span></p>
    </div>
    <div class="modal-footer">
      <button (click)="keepMeLoggedIn()"  class="btn btn-primary">Keep Me Logged In</button>
    </div>
  </div>
</div>

